var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.475,
    height: 26.475,
    viewBox: "0 0 26.475 26.475",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-help-buoy",
    "data-name": "Icon ionic-ios-help-buoy",
    d: "M16.613,3.375A13.238,13.238,0,1,0,29.85,16.613,13.236,13.236,0,0,0,16.613,3.375Zm3.475,2.317a11.485,11.485,0,0,1,7.446,7.446l-5.651.382a6.111,6.111,0,0,0-2.157-2.164ZM8.511,8.511a11.374,11.374,0,0,1,4.627-2.819l.363,5.664a6.251,6.251,0,0,0-2.157,2.157l-5.658-.375A11.5,11.5,0,0,1,8.511,8.511Zm4.627,19.023a11.485,11.485,0,0,1-7.446-7.446l5.664-.363a6.162,6.162,0,0,0,2.151,2.151Zm3.475-6.593a4.328,4.328,0,1,1,4.328-4.328A4.332,4.332,0,0,1,16.613,20.94Zm8.1,3.774a11.416,11.416,0,0,1-4.627,2.819l-.375-5.658a6.13,6.13,0,0,0,2.17-2.177l5.651.382A11.4,11.4,0,0,1,24.714,24.714Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#5e2b97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "static/media/Icon-help.a5f896d7299f555f26d44da0c99c3ec7.svg";
export { ForwardRef as ReactComponent };